<template>
  <div>

    <b-row>
      <b-col sm="12">
        <b-card>

          <div slot="header">
            <strong :style="{color: config.primaryColor}">Transactions API </strong>
            <small :style="{color: config.secondaryColor}"> Filter Form</small>
          </div>

          <b-row>
            <b-col sm="6">

              <b-form-group>
                <label :style="{color: config.primaryColor}">Store Number Filter</label>
                <b-form-input type="text" v-model="storeNumberFilter" placeholder="Store Number Filter"></b-form-input>
              </b-form-group>

            </b-col>

            <b-col sm="6">
              <b-form-group>
                <label :style="{color: config.primaryColor}">Site Id Filter</label>
                <b-form-input type="text" v-model="siteIdFilter" placeholder="Site ID Filter"></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col sm="6">

              <b-form-group>
                <label :style="{color: config.primaryColor}">Batch Id Filter</label>
                <b-form-input type="text" v-model="batchIdFilter" placeholder="Batch ID Filter"></b-form-input>
              </b-form-group>

            </b-col>

            <b-col sm="6">

              <b-form-group>
                <label :style="{color: config.primaryColor}">Aggregate Batch Id Filter</label>
                <b-form-input type="text" v-model="aggregateBatchIdFilter"
                              placeholder="Aggregate Batch ID Filter"></b-form-input>
              </b-form-group>

            </b-col>

          </b-row>

          <b-row>

            <b-col sm="6">
              <b-form-group>
                <label :style="{color: config.primaryColor}">Tran Type Filter</label>
                <b-form-select size="lg" :plain="true" v-model="transTypeFilter"
                               :options="transTypeOptions"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group>
                <label :style="{color: config.primaryColor}">Product Id Filter</label>
                <b-form-input type="text" v-model="productIdFilter" placeholder="Product Id Filter"></b-form-input>
              </b-form-group>
            </b-col>


            <b-col sm="6">
              <b-form-group>
                <label :style="{color: config.primaryColor}">Table(s) Filter</label>
                <b-form-select :plain="true"
                               :multiple="true"
                               :options="tableNameOptions"
                               v-model="tableNamesFilter">
                </b-form-select>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col xs="12">
              <b-form-group>
                <label :style="{color: config.primaryColor}">From Date - To Date Range Filter</label><br>
                <date-picker v-model="times" range type="datetime" lang="en" :format="timeFormat"></date-picker>
              </b-form-group>
            </b-col>
          </b-row>


          <b-row>
            <b-col xs="12">
              <div class="form-group form-actions">
                <button @click="getTransactions" class="btn btn btn-sm btn-secondary btn-secondary">Get Transactions
                </button>
              </div>
            </b-col>
          </b-row>

        </b-card>
      </b-col>
    </b-row>

    <Table v-show="filteredTransactions.length > 0"
           caption="Transaction Documents"
           :data="filteredTransactions"
           :hover="true"
           :perPage="10">
    </Table>

    <Loading
      :show="loading"
      :label="loadingLabel">
    </Loading>

  </div>
</template>

<script>
  import moment from 'moment';

  import store from './store';

  import Table from './Table';
  import Loading from 'vue-full-loading';
  import DatePicker from 'vue2-datepicker';

  import SSR from './ssr';

  export default {
    name: "CompanyTransactions",
    mixins: [SSR],
    components: {DatePicker, Loading, Table},
    props: ['config', 'companyId', 'accessToken'],

    data() {
      return {
        store,
        state: store.state,

        times: [],
        transactions: [],

        siteIdFilter: null,
        storeNumberFilter: null,

        productIdFilter: null,
        batchIdFilter: null,
        aggregateBatchIdFilter: null,
        transTypeFilter: null,
        transTypeOptions: ['', 'insertRow', 'updateRow', 'deleteRow'],
        tableNamesFilter: [],

        statusFilterOptions: ['', 'success', 'failure'],

        loading: false,
        loadingLabel: "Loading Transactions...",
        timeFormat: 'YYYY-MM-DD HH:mm:ss',
        timePickerOptions: {
          start: '00:00',
          step: '00:30',
          end: '23:30'
        }
      }
    },

    methods: {
      getTransactions(skip, callingSelf) {
        this.loading = true;

        skip = skip || 0;
        callingSelf = callingSelf || false;
        let additionalParams = {};

        if (callingSelf) {
          additionalParams["skip"] = skip
        }

        this.$http.get(`${this.olBaseURL}/transactions`, {
          headers: this.headers,
          params: {...this.params, ...additionalParams}
        }).then(res => {

          if (callingSelf && res.body !== undefined) {

            if (res.body.items && res.body.items.length > 0) {
              this.transactions.push(...res.body.items);
            }

          } else {

            if (res.body.items && res.body.items.length > 0) {
              this.transactions = res.body.items;
            }

            this.loading = false;
          }

          let pageSize = res.body.page_size;
          let pageCount = res.body.page_count;
          let currentPage = res.body.current_page;

          if (currentPage !== pageCount) {
            this.getTransactions(pageSize * currentPage + 1, true)
          } else {
            this.loading = false;
          }

        }, err => {
          console.log(err);
          this.loading = false;
        })
      },

      formatTableName(tableName) {
        let tableSplit = tableName.split("_");

        return tableSplit[tableSplit.length - 1]
      },

    },

    computed: {
      headers() {
        let h = {
          Authorization: `Bearer ${this.accessToken}`,
          "X-Company-Id": this.companyId
        };

        if (this.siteIdFilter) {
          h["X-Site-Ids"] = this.siteIdFilter
        }

        return h;
      },
      params() {

        let p = {
          "limit": 10000,
          "from_date": this.fromTime,
          "to_date": this.toTime
        };

        if (this.storeNumberFilter) {
          p["store_number"] = this.storeNumberFilter;
        }

        if (this.transTypeFilter) {
          p["type"] = this.transTypeFilter
        }

        if (this.tableNamesFilter.length > 0) {
          p["table_names"] = this.commaSepTableNames
        }

        if (this.productIdFilter) {
          p["product_id"] = this.productIdFilter
        }

        return p;

      },

      fromTime() {
        if (this.times.length > 0) {
          return moment.utc(this.times[0], this.timeFormat).format();
        }
      },

      toTime() {
        if (this.times.length > 0) {
          return moment.utc(this.times[1], this.timeFormat).format();
        }
      },

      tableNameOptions() {
        let tables = [
          "IRIS_dbo_tbl_OrderSource",
          "IRIS_dbo_tblTax",
          "IRIS_dbo_tbl_PayType",
          "IRIS_dbo_tbl_UpsizeType",
          "IRIS_dbo_tbl_UpsizeItem",
          "IRIS_dbo_tbl_UpsizeGroup",
          "IRIS_dbo_tblDiscounts",
          "IRIS_dbo_tblDiscountLinks",
          "IRIS_dbo_tbl_MenuBtns",
          "IRIS_dbo_tbl_MenuMaster",
          "IRIS_dbo_tblDestination",
          "IRIS_dbo_tblDestinationConfigValues",
          "IRIS_dbo_tblDestinationConfigSettings",
          "IRIS_dbo_tbl_ItemMaster",
          "IRIS_dbo_tbl_ItemPeriods",
          "IRIS_dbo_tbl_ItemPricing",
          "IRIS_dbo_tbl_ItemCatLinks",
          "IRIS_dbo_tbl_ItemModifiers",
          "IRIS_dbo_tbl_ItemCategories",
          "IRIS_dbo_tbl_ItemComponents",
          "IRIS_dbo_tbl_ItemAttachments",
          "IRIS_dbo_tbl_ItemPricing_Child",
          "IRIS_dbo_tbl_ItemTaxCategories",
          "IRIS_dbo_tbl_ItemModifierGroups",
          "IRIS_dbo_tbl_ModifierGroupMembers"
        ];

        return tables.map(tableName => {
          return {
            text: tableName,
            value: tableName
          }
        });
      },

      commaSepTableNames() {
        return this.tableNamesFilter.join(",")
      },

      formattedTransactions() {
        return this.transactions.map(tran => {


          return {
            store_number: tran.store_number,
            site_id: tran.site_id,
            table: this.formatTableName(tran.tran.table),
            user: tran.tran.user,
            type: tran.tran.type,
            start_time: tran.start_time,
            end_time: tran.end_time,
            aggregate_batch_id: tran.aggregate_batch_id
          }
        })

      },

      filteredTransactions() {
        let filtered = this.formattedTransactions;

        if (this.storeNumberFilter) {
          filtered = filtered.filter(tran => tran.store_number === this.storeNumberFilter);
        }

        if (this.batchIdFilter) {
          filtered = filtered.filter(tran => tran.batch_id === this.batchIdFilter);
        }

        if (this.aggregateBatchIdFilter) {
          filtered = filtered.filter(tran => tran.aggregate_batch_id === this.aggregateBatchIdFilter);
        }

        if (this.transTypeFilter) {
          filtered = filtered.filter(tran => this.transTypeFilter.includes(tran.type));
        }


        if (this.tableNamesFilter.length > 0) {
          let formattedTableNameFilters = this.tableNamesFilter.map(name => this.formatTableName(name));
          filtered = filtered.filter(tran => formattedTableNameFilters.includes(tran.table_name));
        }

        return filtered;
      },
    }
  }
</script>

<style scoped>
  select.form-control[size] {
    height: 35px;
  }

  select.form-control[multiple] {
    height: 100px;
  }

</style>
